export const services = {
  pageTitle: 'Nos Services',
  pageSubtitle: 'Des solutions complètes pour tous vos projets de rénovation et construction à Bruxelles',
  
  // Masonry
  masonryTitle: 'Maçonnerie',
  masonryDescription: 'Des travaux de maçonnerie solides et durables pour sécuriser et valoriser votre bien immobilier',
  masonryFeature1: 'Construction de murs porteurs',
  masonryFeature2: 'Réparation de façades',
  masonryFeature3: 'Fondations et dalles',
  masonryFeature4: 'Travaux de briquetage',
  
  // Bathroom & Kitchen
  bathroomTitle: 'Salle de bain & Cuisine',
  bathroomDescription: 'Des espaces modernes, fonctionnels et esthétiques, conçus pour votre confort quotidien',
  bathroomFeature1: 'Rénovation complète',
  bathroomFeature2: 'Installation sanitaire',
  bathroomFeature3: 'Carrelage et revêtements',
  bathroomFeature4: 'Aménagement sur mesure',
  
  // Painting & Finishes
  paintingTitle: 'Peinture & Finitions',
  paintingDescription: 'Des finitions soignées qui subliment vos espaces et assurent un rendu impeccable dans le temps',
  paintingFeature1: 'Peinture intérieure et extérieure',
  paintingFeature2: 'Préparation des surfaces',
  paintingFeature3: 'Pose de papier peint',
  paintingFeature4: 'Finitions décoratives',
  
  // Partitions & Insulation
  partitionTitle: 'Cloisons & Isolation',
  partitionDescription: 'Une isolation performante pour améliorer votre confort thermique et réduire vos dépenses énergétiques',
  partitionFeature1: 'Cloisons en plaques de plâtre',
  partitionFeature2: 'Isolation thermique',
  partitionFeature3: 'Isolation acoustique',
  partitionFeature4: 'Aménagement d\'espaces',
  
  // Carpentry
  carpentryTitle: 'Menuiserie',
  carpentryDescription: 'Installation et rénovation de portes, fenêtres et aménagements sur mesure avec un savoir-faire artisanal',
  carpentryFeature1: 'Portes intérieures et extérieures',
  carpentryFeature2: 'Fenêtres et châssis',
  carpentryFeature3: 'Parquets et revêtements',
  carpentryFeature4: 'Aménagements sur mesure',
  
  // Electrical
  electricalTitle: 'Électricité',
  electricalDescription: 'Installations électriques conformes aux normes belges pour votre sécurité et votre tranquillité',
  electricalFeature1: 'Installation électrique complète',
  electricalFeature2: 'Mise aux normes',
  electricalFeature3: 'Éclairage et domotique',
  electricalFeature4: 'Dépannage et maintenance',
  
  // CTA
  ctaTitle: 'Besoin d\'un devis pour votre projet ?',
  ctaDescription: 'Contactez-nous pour discuter de votre projet et recevoir un devis gratuit et personnalisé',
  ctaButton: 'Demander un devis gratuit'
};